export const EmptyState = ({ icon: Icon, title, description, testId }) => {
  return (
    <div
      data-testid={testId}
      className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-zinc-800 bg-eb-surface/40 px-6 py-10 text-center"
    >
      {Icon && <Icon size={28} weight="light" className="text-zinc-600" />}
      <p className="font-heading text-sm uppercase tracking-wide text-zinc-400">{title}</p>
      {description && <p className="max-w-xs text-xs text-zinc-600">{description}</p>}
    </div>
  );
};
